/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsBaselineResponse {
    getFixupPrototypeFunction() { return AIUnitEconomicsBaselineResponse.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsBaselineResponse>): AIUnitEconomicsBaselineResponse {
        let obj = Object.assign(new AIUnitEconomicsBaselineResponse(), model);
        AIUnitEconomicsBaselineResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsBaselineResponse>): AIUnitEconomicsBaselineResponse {
        if (!model) return null;
        return AIUnitEconomicsBaselineResponse.newInstance(<AIUnitEconomicsBaselineResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsBaselineResponse) {
        if (!obj) return;

        models.AIUnitEconomicsBaselineResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsBaselineResponse): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsBaselineResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.quality_scale === undefined) {
            this.quality_scale = 0;
        }
        if (this.entry_count === undefined) {
            this.entry_count = 0;
        }
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.configuration) {
            for (let val of this.configuration) {
                models.AIUnitEconomicsBaselineConfigurationEntry.fixupPrototype(val);
            }
        }
    }

    /**
     * Baseline ID
     */
    id: string;

    /**
     * Display name of the baseline
     */
    name: string;

    /**
     * Scope the baseline applies to. 'tenant' requires applicable_entity_id; 'master_account' must omit it and applies to the caller's master account
     */
    scope: models.AIUnitEconomicsBaselineScope;

    /**
     * Entity the baseline applies to: the tenant ID when scope is 'tenant', the master account ID when scope is 'master_account'
     */
    applicable_entity_id: string;

    /**
     * First day the baseline applies to
     */
    start_date: Date;

    /**
     * End of the baseline period (exclusive)
     */
    end_date: Date;

    /**
     * Field the consolidation job matches cost on
     */
    primary_key: string;

    /**
     * Unit the manual and AI duration fields are expressed in
     */
    duration_unit: models.AIUnitEconomicsDurationUnit;

    /**
     * Upper bound for the quality score fields
     */
    quality_scale: number;

    /**
     * Number of entries in the baseline configuration
     */
    entry_count: number;

    /**
     * Creation time
     */
    created_at: Date;

    /**
     * Last update time
     */
    updated_at: Date;

    /**
     * User who created the baseline
     */
    created_by: string;

    /**
     * User who last updated the baseline
     */
    updated_by: string;

    /**
     * Baseline entries; omitted from list responses unless requested
     */
    configuration: Array<models.AIUnitEconomicsBaselineConfigurationEntry>;

}
